import { Segmented } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import COLORS from "common/Colors";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { getMenuList, getUserRoleId } from "redux/selectors";
import KpiPlanningList from "./KpiPlanningList";
import AppraisalList from "./AppraisalList";
import KpiViewModal from "./KpiViewModal";

const PerformanceKpiManagementWrap = styled.div`
  .ant-segmented {
    background: #f5f5f5;
    border-radius: 20px;
    padding: 4px;
    margin: 16px 0;
  }
  .ant-segmented-item {
    border-radius: 16px;
    font-weight: 500;
    font-size: 15px;
    color: ${COLORS.TEXT.PRIMARY};
    padding: 4px 8px;
  }
  .ant-segmented-item-selected {
    background: #e3e8fc;
    color: ${COLORS.TAB};
    font-weight: 600;
  }
  .header-divider {
    display: inline-block;
    width: 1px;
    height: 16px;
    background: #d9d9d9;
  }
`;

const PerformanceKpiManagement = () => {
  const history = useHistory();
  const location = useLocation();
  const [tabId, setTabId] = useState(location.state?.id || "kpiplanning");
  const [kpiViewOpen, setKpiViewOpen] = useState(false);
  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);

  useEffect(() => {
    if (location.state?.id) setTabId(location.state.id);
  }, [location.state]);

  // Both entries share key "hrperformance" - only menuName tells the
  // company-level "KPI" preview apart from the "Company & Departmental KPIs"
  // management page, so each header link is gated on its own menuName.
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0] || menuList;
  const canViewKpi = Menulist?.find(
    (item) => item?.menuName === "Performance - KPI" && item?.permission?.view
  );
  const canViewDepartmentKpi = Menulist?.find(
    (item) => item?.menuName === "Performance - Department KPI" && item?.permission?.view
  );

  const options = [
    { label: "KPI Planning", value: "kpiplanning" },
    { label: "Appraisal", value: "appraisal" },
  ];

  return (
    <PerformanceKpiManagementWrap>
      <div className="d-flex justify-content-between align-items-center">
        <h6>Performance Management – Balanced Score Card</h6>
        {(canViewKpi || canViewDepartmentKpi)  &&(
        <div className="d-flex align-items-center gap-3">
          {canViewKpi &&(
<>
<span style={{ cursor: "pointer", color: COLORS.PRIMARY }} onClick={() => setKpiViewOpen(true)}>
  <EyeOutlined /> Company KPI
</span>
<span className="header-divider" />
</>
          )}
          {canViewDepartmentKpi && (

          <span
            className="lite-text"
            style={{ cursor: "pointer", color: COLORS.PRIMARY }}
            onClick={() => history.push("/performance-kpi-company-department")}
          >
            Company & Departmental KPIs
          </span>
          )}
        </div>)}
      </div>
      <Segmented value={tabId} onChange={setTabId} options={options} />
      {tabId === "kpiplanning" ? <KpiPlanningList /> : <AppraisalList />}

      <KpiViewModal open={kpiViewOpen} onClose={() => setKpiViewOpen(false)} />
    </PerformanceKpiManagementWrap>
  );
};

export default PerformanceKpiManagement;
